import { root } from '../UniversalUtils';

export const addRequestIdleCallbackPolyfill = () => {
    root.requestIdleCallback =
        root.requestIdleCallback ||
        function (cb: Function) {
            // eslint-disable-next-line no-var
            var start = Date.now();

            return setTimeout(function () {
                cb({
                    didTimeout: false,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - start));
                    }
                });
            }, 1);
        };

    root.cancelIdleCallback =
        root.cancelIdleCallback ||
        function (id: number) {
            clearTimeout(id);
        };
};
